// extracted by mini-css-extract-plugin
export default {"home":"Complaints_home__s6bOy","home2":"Complaints_home2__kgHA8","main":"Complaints_main__AYIcK"};